import { faBell } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge, Nav, NavItem } from 'react-bootstrap'
import Notifications from '../../../processes/Notifications'
import { useAppSelector } from '../../../../store/hooks'
import useNotificationPolling from '../../../../hooks/useNotificationPolling'

const NotificationsMenuItem = () => {
    const initData = useAppSelector((state: any) => state.security.initData)

    useNotificationPolling()

    const unreadCount = initData?.processes?.notifications?.unreadCount ?? 0

    return (
        <Nav.Item as="li" className="nav-notifications">
            <Notifications
                type="icon"
                trigger={
                    <span className="nav-link nav-notifications__trigger" role="button">
                        <FontAwesomeIcon icon={faBell} className="nav-notifications__icon" />
                        {unreadCount > 0 && (
                            <Badge
                                bg="danger"
                                className="nav-notifications__badge"
                                pill
                            >
                                {unreadCount >= 100 ? '99+' : unreadCount}
                            </Badge>
                        )}
                    </span>
                }
            />
        </Nav.Item>
    )
}

export default NotificationsMenuItem
